import React from 'react'
import { useIntl } from 'react-intl'

import Button, { ButtonProps } from 'src/comps/Atom/Buttons/Button'

import messages from './messages'
import ChevronRight from 'client/icons/ChevronRight'

interface BookingButtonProps extends ButtonProps {
  price?: React.ReactElement
  isMultiRoom?: boolean
}

const BookingButton: React.FC<BookingButtonProps> = ({ price, isMultiRoom = false, ...props }) => {
  const intl = useIntl()
  const buttonText = isMultiRoom ? messages.select : messages.book

  return (
    <Button
      rounded
      loaderPosition="content"
      backgroundColor="brand1"
      borderColor="brand1"
      color="grey8"
      type="button"
      {...props}
      rightIcon={<ChevronRight />}
    >
      <p>{intl.formatMessage(buttonText)}</p>
      {price && <span>{intl.formatMessage(messages.priceNight, { price })}</span>}
    </Button>
  )
}

export default BookingButton
